module.exports = __webpack_public_path__ + "static/media/yt-icon.10350fbb.svg";